// removed by extract-text-webpack-plugin
module.exports = {"classModal":"Modal-classModal-c946f8e5","classModalContentClose":"Modal-classModalContentClose-730cd043","classModalContent":"Modal-classModalContent-029e5aed","fadeIn":"Modal-fadeIn-a1d5e3a2","classModalOpen":"Modal-classModalOpen-805e14bb","classModalClose":"Modal-classModalClose-2593fd83","classModalHidden":"Modal-classModalHidden-20fec386","classModalIcon":"Modal-classModalIcon-b3b79db9"};


//////////////////
// WEBPACK FOOTER
// ./src/themes/defaults/sass/components/Modal.scss
// module id = 912
// module chunks = 0